import { generateClient } from "aws-amplify/api";
import { getUserStatsDistribution, getDashboardData } from "@/graphql/queries";
const client = generateClient();
export const GetDashboardMetrics = {
  methods: {
    async GetMetricsDataMethod() {
      try {
        this.loading = true;
        let result = await client.graphql({
          query: getUserStatsDistribution,
          variables: {
            input: {},
          },
        });
        var ResultObj = JSON.parse(result.data.getUserStatsDistribution);
        if (ResultObj.status == 200 || ResultObj.status === "SUCCESS") {
          return ResultObj.data;
        }
        this.loading = false;
      } catch (error) {
        this.GetAllPollsList = [];
        this.loading = false;
        return null;
        console.log("Error", error);
      }
    },
    async GetCountsDataMethod() {
      try {
        this.loading = true;
        let result = await client.graphql({
          query: getDashboardData,
          variables: {
            input: {},
          },
        });
        var ResultObj = JSON.parse(result.data.getDashboardData);
        if (ResultObj.status == 200 || ResultObj.status === "SUCCESS") {
          return ResultObj.data.items?.[0] || {};
        }
        this.loading = false;
      } catch (error) {
        this.GetAllPollsList = [];
        this.loading = false;
        return null;
        console.log("Error", error);
      }
    },
  },
};
